import React from "react";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { connect } from "react-redux";
import { Layouts } from "../../constants/Constants";
import SocialMedia from "./SocialMedia";
import styles from "../../assets/css/modules/shared/footer-min.css";

export const mapStateToProps = (state) => {
  const currentPolicy = state.policyReducer.selectedPolicy;

  return {
    isHOL: state.layoutReducer && state.layoutReducer.layout === Layouts.HOL,
    isSaga: currentPolicy && currentPolicy.IsSaga,
    isInternational: currentPolicy && currentPolicy.IsInternational
  };
};

export const FooterMin = function (props) {
  return (
    <div className="footer footer-min" role="contentinfo" aria-label="Footer">
      {props.isHOL ? (
        <div className="footer-top footer-top-lang-social hidden-xs-down">
          <div className="container">
            <div className={"row " + styles.footerPadding}>
              <section className="col-lg-7 col-sm-7 footer-links">
                <div className="footer-languages-bottom-container hidden-xs-down">
                  <ul className="footer-languages">
                    <li className="footer-language-item">
                      <Content name={Store.Footer.ContactUsUrl}>
                        {(ContactUsUrl) => (
                          <a
                            href={ContactUsUrl}
                            className="footer-language-link active-language text-capitalize"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            Contact Us
                          </a>
                        )}
                      </Content>
                    </li>
                  </ul>
                </div>
              </section>
              <section className="col-lg-5 col-sm-5 footer-light-social-top-container">
                <div className="clear-gutter">
                  <SocialMedia />
                </div>
              </section>
            </div>
          </div>
        </div>
      ) : null}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            {props.isHOL ? (
              <React.Fragment>
                <div className="footer-languages-social-bottom-container footer-languages-bottom-container hidden-sm-up container">
                  <SocialMedia />
                </div>
                <div className="footer-languages-links-bottom-container footer-languages-bottom-container hidden-sm-up container">
                  <ul className="footer-languages">
                    <li className="footer-language-item">
                      <Content name={Store.Footer.ContactUsUrl}>
                        {(ContactUsUrl) => (
                          <a
                            href={ContactUsUrl}
                            rel="noopener noreferrer"
                            target="_blank"
                            className="footer-language-link active-language"
                          >
                            Contact Us
                          </a>
                        )}
                      </Content>
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            ) : null}
            <div className="footer-copyline footer-copyline-bottom">
              {!props.isInternational && !props.isSaga ? (
                <Content name={Store.Footer.AxaHealthAbout}>
                  {(axaHealthAbout) => (
                    <a
                      href={axaHealthAbout}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Information about AXA Health
                    </a>
                  )}
                </Content>
              ) : null}
              <Content name={Store.Footer.PrivacyPolicyUrl}>
                {(privacyPolicyUrl) => (
                  <a
                    href={privacyPolicyUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                )}
              </Content>
              <Content name={Store.Footer.CookiePolicyUrl}>
                {(cookiePolicyUrl) => (
                  <a
                    href={cookiePolicyUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Cookie Policy
                  </a>
                )}
              </Content>
              &nbsp;
              <div>
                © {new Date().getFullYear()}
                {"  "}
                <Content name={Store.Footer.WebAppName} />, All Rights Reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(FooterMin);
